import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '@/components/Loader';
import { loginUrlWithRedirect, stashPostLoginRedirect } from '@/utils/postLoginRedirect';
import { LOGIN } from './routes';

// Catch-all for the public router. A path that matches no public route is either a
// protected page opened while logged out (a shared/bookmarked link) or a dead URL —
// indistinguishable without a session, so both go to Login rather than the 404
// errorElement, and the auth handlers replay the target via consumePostLoginRedirect.
// A dead URL therefore 404s on the protected router after sign-in, not before it.
export default function UnauthenticatedRedirect() {
  const navigate = useNavigate();
  const redirectedRef = useRef(false);

  useEffect(() => {
    if (redirectedRef.current) return;
    redirectedRef.current = true;

    // window.location, not useLocation(): there are two separate routers (logged-in
    // and logged-out), and this one doesn't learn about pages visited through the
    // other. Its useLocation() can be stale; window.location is always the real URL.
    const target = `${window.location.pathname}${window.location.search}`;
    stashPostLoginRedirect(target);
    navigate(loginUrlWithRedirect(LOGIN, target), { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Loader />;
}
